import React, { useMemo } from 'react';
import './sidebar.css';
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setLocalStorage } from "../../helpers/LocalStorage";
import {
    addSubscriptionFormAction,
    currentSubscriptionAction,
    currentUserAction,
    dropdownAction,
    notificationsFormAction,
    resetAllFiltersAction,
    searchAction,
    sidebarAction,
    sortAction,
    statisticDatesAction,
    subscriptionFormAction,
    usersAction,
    usersListAction,
    setCashAction
} from "../../redux/rootReducer";
import {
    ADD_SUBSCRIPTION_FORM_INITIAL,
    CASH_INITIAL,
    CURRENT_SUBSCRIPTION_INITIAL,
    CURRENT_USER_INITIAL,
    PUSH_NOTIFICATION_FORM_INITIAL,
    STATISTIC_DATES_INITIAL,
    SUBSCRIPTION_FORM_INITIAL
} from "../../redux/initialStateConstant";

const Sidebar = () => {
    const dispatch = useDispatch();

    const user = useSelector(state => state.user);
    const sidebar = useSelector(state => state.sidebar);
    const tasks_count = useSelector(state => state.tasks_count);
    const establishmentList = useSelector(state => state.establishmentList);
    const currentEstablishment = useSelector(state => state.currentEstablishment);

    const currentEst = useMemo(() => {
        if (establishmentList.length === 0 || !currentEstablishment) return;

        return establishmentList.find(el => el.id === currentEstablishment);
    }, [establishmentList, currentEstablishment]);

    return (
        <div className={ `sidebar ${ sidebar ? 'sidebar--show' : false }` }>
            <i className="sidebar__close" onClick={ () => {
                dispatch(sidebarAction(false));
            } }/>
            <div className="sidebar__navs">
                {
                    user.id === '3' &&
                    <NavLink to={ '/fitness/slugs' } exact activeClassName={ 'sidebar__nav--active' }
                             className="sidebar__nav sidebar__nav--slugs"
                             onClick={ () => {
                                 // Закрываем сайдбар, если он открыт
                                 if (sidebar) {
                                     dispatch(sidebarAction(false));
                                 }
                             } }
                    >
                        <div className="sidebar__nav-ico"/>
                        <div className="sidebar__nav-description">Заведение</div>
                    </NavLink>
                }
                {
                    user.id === '3' &&
                    <NavLink to={ '/fitness/payments' } exact activeClassName={ 'sidebar__nav--active' }
                             className="sidebar__nav sidebar__nav--payments"
                             onClick={ () => {
                                 // Закрываем сайдбар, если он открыт
                                 if (sidebar) {
                                     dispatch(sidebarAction(false));
                                 }
                             } }
                    >
                        <div className="sidebar__nav-ico"/>
                        <div className="sidebar__nav-description">Оплаты</div>
                    </NavLink>
                }
                {
                    user.id === '3' &&
                    <NavLink to={ '/fitness/invoices' } exact activeClassName={ 'sidebar__nav--active' }
                             className="sidebar__nav sidebar__nav--invoices"
                             onClick={ () => {
                                 // Закрываем сайдбар, если он открыт
                                 if (sidebar) {
                                     dispatch(sidebarAction(false));
                                 }
                             } }
                    >
                        <div className="sidebar__nav-ico"/>
                        <div className="sidebar__nav-description">Счета</div>
                    </NavLink>
                }
                <NavLink to={ '/fitness' } exact activeClassName={ 'sidebar__nav--active' }
                         className="sidebar__nav sidebar__nav--monitor"
                         onClick={ () => {
                             dispatch(searchAction(''));

                             // Сброс фильтров
                             dispatch(resetAllFiltersAction());

                             // Закрываем сайдбар, если он открыт
                             if (sidebar) {
                                 dispatch(sidebarAction(false));
                             }
                         } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Мониторинг</div>
                </NavLink>
                <NavLink to={ '/fitness/users' } exact activeClassName={ 'sidebar__nav--active' }
                         className="sidebar__nav sidebar__nav--users"
                         onClick={ () => {
                             dispatch(searchAction(''));
                             dispatch(usersAction([]));
                             dispatch(usersListAction([]));
                             dispatch(dropdownAction(null));
                             dispatch(currentUserAction(CURRENT_USER_INITIAL));
                             // Сброс формы редактирования абонемента
                             dispatch(subscriptionFormAction(SUBSCRIPTION_FORM_INITIAL));
                             // Сброс формы добавления абонемента
                             dispatch(addSubscriptionFormAction(ADD_SUBSCRIPTION_FORM_INITIAL));
                             dispatch(currentSubscriptionAction(CURRENT_SUBSCRIPTION_INITIAL));

                             // Закрываем сайдбар, если он открыт
                             if (sidebar) {
                                 dispatch(sidebarAction(false));
                             }
                         } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Посетители</div>
                </NavLink>
                <NavLink to={ '/fitness/subscriptions' } exact activeClassName={ 'sidebar__nav--active' }
                         className="sidebar__nav sidebar__nav--subscriptions"
                         onClick={ () => {
                             // Очищаем сортировки
                             dispatch(sortAction({
                                 table: '',
                                 field: '',
                                 order: ''
                             }));
                             dispatch(searchAction(''));
                             dispatch(currentUserAction(CURRENT_USER_INITIAL));
                             // Сброс формы добавления и редактирования абонемента
                             dispatch(subscriptionFormAction(SUBSCRIPTION_FORM_INITIAL));
                             dispatch(addSubscriptionFormAction(ADD_SUBSCRIPTION_FORM_INITIAL));
                             dispatch(currentSubscriptionAction(CURRENT_SUBSCRIPTION_INITIAL));

                             // Закрываем сайдбар, если он открыт
                             if (sidebar) {
                                 dispatch(sidebarAction(false));
                             }
                         } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Абонементы</div>
                </NavLink>
                <NavLink to={ '/fitness/workouts' } exact activeClassName={ 'sidebar__nav--active' }
                         onClick={ () => {
                             // Сброс фильтров
                             dispatch(resetAllFiltersAction());

                             // Закрываем сайдбар, если он открыт
                             if (sidebar) {
                                 dispatch(sidebarAction(false));
                             }
                         } }
                         className="sidebar__nav sidebar__nav--workouts"
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Тренировки</div>
                </NavLink>
                <NavLink to={ '/fitness/booking' } exact activeClassName={ 'sidebar__nav--active' }
                         className="sidebar__nav sidebar__nav--booking"
                         onClick={ () => {
                             // Закрываем сайдбар, если он открыт
                             if (sidebar) {
                                 dispatch(sidebarAction(false));
                             }
                             // Сбрасываем текущего пользователя
                             dispatch(currentUserAction(CURRENT_USER_INITIAL));
                         } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Расписание</div>
                </NavLink>
                {
                    currentEst?.schedule_active === 1 &&
                    <NavLink to={ '/fitness/services' } exact activeClassName={ 'sidebar__nav--active' }
                             className="sidebar__nav sidebar__nav--services"
                             onClick={ () => {
                                 // Закрываем сайдбар, если он открыт
                                 if (sidebar) {
                                     dispatch(sidebarAction(false));
                                 }
                                 // Сбрасываем текущего пользователя
                                 dispatch(currentUserAction(CURRENT_USER_INITIAL));
                             } }
                    >
                        <div className="sidebar__nav-ico"/>
                        <div className="sidebar__nav-description">Услуги</div>
                    </NavLink>
                }
                <NavLink to={ '/fitness/sales' } exact activeClassName={ 'sidebar__nav--active' }
                         className="sidebar__nav sidebar__nav--sales"
                         onClick={ () => {
                             // Сброс фильтров
                             dispatch(resetAllFiltersAction());
                             // Сброс текущего пользователя
                             dispatch(currentUserAction(CURRENT_USER_INITIAL));

                             // Закрываем сайдбар, если он открыт
                             if (sidebar) {
                                 dispatch(sidebarAction(false));
                             }
                         } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Продажи</div>
                </NavLink>
                <NavLink
                    to={ '/fitness/tasks' } exact
                    activeClassName={ 'sidebar__nav--active' }
                    className="sidebar__nav sidebar__nav--tasks"
                    onClick={ () => {
                        // Закрываем сайдбар, если он открыт
                        if (sidebar) {
                            dispatch(sidebarAction(false));
                        }
                    } }
                >
                    <div className="sidebar__nav-ico"/>
                    { tasks_count ? <div className="sidebar__tasks">{ tasks_count > 99 ? '99+' : tasks_count }</div> : false }
                    <div className="sidebar__nav-description">Задачи</div>
                </NavLink>
                <NavLink to={ '/fitness/goods' } exact activeClassName={ 'sidebar__nav--active' }
                     className="sidebar__nav sidebar__nav--goods"
                     onClick={ () => {
                         // Закрываем сайдбар, если он открыт
                         if (sidebar) {
                             dispatch(sidebarAction(false));
                         }
                     } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Товары</div>
                </NavLink>
                <NavLink to={ '/fitness/gifts' } exact activeClassName={ 'sidebar__nav--active' }
                    className="sidebar__nav sidebar__nav--gifts"
                    onClick={ () => {
                        // Сброс фильтров
                        dispatch(resetAllFiltersAction());

                        // Закрываем сайдбар, если он открыт
                        if (sidebar) {
                            dispatch(sidebarAction(false));
                        }
                    } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Бонусы</div>
                </NavLink>
                <NavLink to={ '/fitness/reviews' } exact activeClassName={ 'sidebar__nav--active' }
                         className="sidebar__nav sidebar__nav--reviews"
                         onClick={ () => {
                             // Сброс фильтров
                             dispatch(resetAllFiltersAction());

                             // Закрываем сайдбар, если он открыт
                             if (sidebar) {
                                 dispatch(sidebarAction(false));
                             }
                         } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Отзывы</div>
                </NavLink>
                <NavLink to={ '/fitness/statistic' } exact activeClassName={ 'sidebar__nav--active' }
                         className="sidebar__nav sidebar__nav--statistic"
                         onClick={ () => {
                             dispatch(statisticDatesAction(STATISTIC_DATES_INITIAL));
                             // Закрываем сайдбар, если он открыт
                             if (sidebar) {
                                 dispatch(sidebarAction(false));
                             }
                         } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Статистика</div>
                </NavLink>
                <NavLink to={ '/fitness/settings' } exact activeClassName={ 'sidebar__nav--active' }
                         className="sidebar__nav sidebar__nav--settings"
                         onClick={ () => {
                             // Закрываем сайдбар, если он открыт
                             if (sidebar) {
                                 dispatch(sidebarAction(false));
                             }
                         } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Настройки</div>
                </NavLink>
                <NavLink to={ '/fitness/cash' } exact activeClassName={ 'sidebar__nav--active' }
                         className="sidebar__nav sidebar__nav--cash"
                         onClick={ () => {
                             // Сброс фильтров
                             dispatch(resetAllFiltersAction());
                             // Сброс данных кассы
                             dispatch(setCashAction(CASH_INITIAL));
                             // Закрываем сайдбар, если он открыт
                             if (sidebar) {
                                 dispatch(sidebarAction(false));
                             }
                         } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Касса</div>
                </NavLink>
                <NavLink to={ '/fitness/account' } exact activeClassName={ 'sidebar__nav--active' }
                         className="sidebar__nav sidebar__nav--account"
                         onClick={ () => {
                             // Закрываем сайдбар, если он открыт
                             if (sidebar) {
                                 dispatch(sidebarAction(false));
                             }
                         } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Аккаунт</div>
                </NavLink>
                <NavLink to={ '/fitness/notifications' } exact activeClassName={ 'sidebar__nav--active' }
                         className="sidebar__nav sidebar__nav--notifications"
                    onClick={ () => {
                        dispatch(notificationsFormAction(PUSH_NOTIFICATION_FORM_INITIAL));

                        // Закрываем сайдбар, если он открыт
                        if (sidebar) {
                            dispatch(sidebarAction(false));
                        }
                    } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Рассылка</div>
                </NavLink>
                <NavLink to={ '/fitness/promo' } exact activeClassName={ 'sidebar__nav--active' }
                     className="sidebar__nav sidebar__nav--promo"
                     onClick={ () => {
                         // Закрываем сайдбар, если он открыт
                         if (sidebar) {
                             dispatch(sidebarAction(false));
                         }
                     } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Акции и новости</div>
                </NavLink>
                <NavLink to={ '/fitness/qr' } exact activeClassName={ 'sidebar__nav--active' }
                         className="sidebar__nav sidebar__nav--qr"
                         onClick={ () => {
                             // Закрываем сайдбар, если он открыт
                             if (sidebar) {
                                 dispatch(sidebarAction(false));
                             }
                         } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">QR-код</div>
                </NavLink>
                <NavLink to={ '/fitness/coaches' } exact activeClassName={ 'sidebar__nav--active' }
                         className="sidebar__nav sidebar__nav--coaches"
                         onClick={ () => {
                             // Закрываем сайдбар, если он открыт
                             if (sidebar) {
                                 dispatch(sidebarAction(false));
                             }
                         } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Тренеры</div>
                </NavLink>
                {
                    user.role === 'super_admin' &&
                    <NavLink to={ '/fitness/salary' } exact activeClassName={ 'sidebar__nav--active' }
                             className="sidebar__nav sidebar__nav--salary"
                             onClick={ () => {
                                 // Закрываем сайдбар, если он открыт
                                 if (sidebar) {
                                     dispatch(sidebarAction(false));
                                 }
                             } }
                    >
                        <div className="sidebar__nav-ico"/>
                        <div className="sidebar__nav-description">Зарплаты</div>
                    </NavLink>
                }
                <NavLink to={ '/fitness/price' } exact activeClassName={ 'sidebar__nav--active' }
                     className="sidebar__nav sidebar__nav--price"
                     onClick={ () => {
                         // Закрываем сайдбар, если он открыт
                         if (sidebar) {
                             dispatch(sidebarAction(false));
                         }
                     } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Прайс</div>
                </NavLink>
                <NavLink to={ '/fitness/leaderboard' } exact activeClassName={ 'sidebar__nav--active' }
                         className="sidebar__nav sidebar__nav--leaderboard"
                         onClick={ () => {
                             // Закрываем сайдбар, если он открыт
                             if (sidebar) {
                                 dispatch(sidebarAction(false));
                             }
                         } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Таблица лидеров</div>
                </NavLink>
                {/*<NavLink to={ '/fitness/automation' } exact activeClassName={ 'sidebar__nav--active' }*/}
                {/*         className="sidebar__nav sidebar__nav--automation"*/}
                {/*>*/}
                {/*    <div className="sidebar__nav-ico"/>*/}
                {/*    <div className="sidebar__nav-description">Автом-ции</div>*/}
                {/*</NavLink>*/}
                {
                    user.role === 'super_admin' &&
                    <NavLink to={ '/fitness/admins' } exact activeClassName={ 'sidebar__nav--active' }
                             className="sidebar__nav sidebar__nav--admins"
                             onClick={ () => {
                                 // Закрываем сайдбар, если он открыт
                                 if (sidebar) {
                                     dispatch(sidebarAction(false));
                                 }
                             } }
                    >
                        <div className="sidebar__nav-ico"/>
                        <div className="sidebar__nav-description">Админы</div>
                    </NavLink>
                }
                {
                    (process.env.NODE_ENV === 'development' || user.slug !== 'fitness') &&
                    <NavLink to={ '/fitness/improvements' } exact activeClassName={ 'sidebar__nav--active' }
                             className="sidebar__nav sidebar__nav--improvements"
                             onClick={ () => {
                                 // Закрываем сайдбар, если он открыт
                                 if (sidebar) {
                                     dispatch(sidebarAction(false));
                                 }
                             } }
                    >
                        <div className="sidebar__nav-ico"/>
                        <div className="sidebar__nav-description">Доработки</div>
                        <div className="sidebar__nav-date">24.04.2026</div>
                    </NavLink>
                }
                {
                    (process.env.NODE_ENV === 'development' || user.slug !== 'fitness') &&
                    <div className="sidebar__nav sidebar__nav--info"
                         onClick={ () => {
                             window.location.href = 'https://alga.by/fitness_tutorial';
                         } }
                    >
                        <div className="sidebar__nav-ico"/>
                        <div className="sidebar__nav-description">Инфо</div>
                    </div>
                }
                <div className="sidebar__nav sidebar__nav--logout"
                     onClick={ () => {
                         setLocalStorage('afp_fitness', '').then(() => window.location.reload());
                     } }
                >
                    <div className="sidebar__nav-ico"/>
                    <div className="sidebar__nav-description">Выход</div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;